import React from 'react'
import SortableTree from 'react-sortable-tree'

export default class TreeView extends React.Component {
  render () {
    return (<SortableTree
      isVirtualized={false}
      rowHeight={40}
      scaffoldBlockPxWidth={30}
      {...this.props}
    />)
  }
}



// WEBPACK FOOTER //
// ./src/components/TreeView/TreeView.js